<template>
	<div class="header-main">
		<img class="logo" src="../assets/images/logo1.png">
		<div class="header-right">
			<!-- <span v-if="showUser()">身份:{{agent}}&nbsp;&nbsp;&nbsp;&nbsp;用户名:{{userInfo.username}} -->
			<span v-if="showUser()">用户名:{{userInfo.username}}
				&nbsp;&nbsp;&nbsp;&nbsp;<a href="javascript:;" @click="logout">注销</a>
			</span>
			<a href="http://www.tizdata.com" target="_blank">天智官网</a>
			<a v-if="userInfo.is_staff && $route.path.indexOf('admin') == -1" href="/#/admin">后台管理</a>
			<a v-if="userInfo.is_staff && $route.path.indexOf('admin') != -1" href="/#/">前台管理</a>
		</div>
	</div>
</template>

<script>
import { getUserInfo  } from '@/utils/auth'
import { agentType }  from "@/utils/dataDict";
export default {
		data() {
			return{
				userInfo:{},
				agent:"",
				pathFilter:['/','/login','/register']
			}
		},
		mounted(){
			this.getUserInfo()
			try {
				this.agent = agentType[this.userInfo.agent_info.cooperation_type]
			} catch (error) {
				this.agent = "未认证"
			}
		},
		methods: {
			getUserInfo(){
				this.userInfo = this.$store.getters.userInfo
			},
			showUser(){
				if(this.pathFilter.indexOf(this.$route.path) !=-1){
					return false
				}
				return true
			},
			logout(){
				this.$store.dispatch("user/logout").then(()=>{
					this.$router.push({path:'/login'})
				})
			}
		},
		watch:{
			userInfo:function(){

			}
		}
	};
</script>

<style lang='scss'>
	.header-main {
		margin: 0px;
		width: 100%;
		height: 60px;
		line-height: 60px;
		background-color: #1a6aa3;
		.logo{
			height: 34px;
		}
	}
	
	.header-main img {
		margin-left: 24px;
		vertical-align: middle;
	}
	
	.header-right {
		float: right;
		// width: 400px;
		height: 60px;
	}
	
	.header-right a,.header-right span {
		float: right;
		margin-right: 24px;
		height: 60px;
		font-size: 12px;
		line-height: 60px;
		letter-spacing: 0px;
		color: #ffffff;
		opacity: 0.7;
	}
	
	.header-right a:hover {}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue